export interface LearnProgress {
  videoId: string;
  progress: number;
  completion: Date;
}

export interface LearnProgressforRecommendation {
  videoId: string;
  watched?: Date;
  completed?: Date;
}

export interface FilterCategory {
  name: string;
  code: string;
  filters: Array<string>;
}

export interface LearnLike {
  id: string;
  like: number;
}

export enum LearnSort {
  POSTED_DATE = 'POSTED_DATE',
  RECENTLY_WATCHED = 'RECENTLY_WATCHED',
  RECENTLY_SAVED = 'RECENTLY_SAVED'
}
